<div
  class="d-flex flex-nowrap align-items-center gap-3 w-100 justify-content-center"
>
  <div class="col-auto">
    <button
      class="btn btn-light border"
      (click)="add(-1)"
      [disabled]="count <= min"
    >
      -
    </button>
  </div>
  <div class="col-auto fs-22">
    <b>{{ count | numberTranslate }}</b>
  </div>
  <div class="col-auto">
    <button
      class="btn btn-light border"
      (click)="add(1)"
      [disabled]="count >= max"
    >
      +
    </button>
  </div>
</div>
